import { cn } from "@heroui/react";
import { createPortal } from "react-dom";
import { useEffect, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

const CustomModal = ({
  isOpen,
  children,
  width = "430px",
  className = "",
  overlayClassName = "",
  expandable = false,
  defaultMaximized = false,
}) => {
  const [isMaximized, setIsMaximized] = useState(defaultMaximized);

  useEffect(() => {
    if (isOpen) {
      setIsMaximized(defaultMaximized);
    }
  }, [isOpen, defaultMaximized]);

  if (!isOpen) return null;

  const content = (
    <div
      className={cn(
        "fixed inset-0 z-[99999] flex items-center justify-center bg-black/15 backdrop-blur-sm w-full",
        overlayClassName,
      )}
      role="presentation"
    >
      <div
        role="dialog"
        aria-modal="true"
        onClick={(e) => e.stopPropagation()}
        className={cn(
          "drop-shadow rounded-2xl max-h-[90dvh] bg-white dark:bg-gray-900 dark:border dark:border-gray-800 dark:text-gray-100 overflow-hidden p-8 flex flex-col gap-4 items-center scrollbar-hide relative transition-[width,max-width] duration-300 ease-in-out",
          className,
        )}
        style={{
          width: isMaximized ? "90vw" : width,
          maxWidth: "95vw",
        }}
      >
        {expandable && (
          <button
            type="button"
            onClick={() => setIsMaximized((prev) => !prev)}
            className="absolute top-6 right-14 p-1 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 transition-colors z-[100000002] flex items-center justify-center cursor-pointer"
            aria-label={isMaximized ? "Minimize modal" : "Maximize modal"}
          >
            {isMaximized ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
          </button>
        )}
        <div className="flex w-full min-h-0 flex-1 flex-col overflow-y-auto">
          {children}
        </div>
      </div>
    </div>
  );

  if (typeof document !== "undefined") {
    return createPortal(content, document.body);
  }

  return content;
};

export default CustomModal;
